import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import { GROUPS as CONSTS, ROLE } from '../../const';
import { getStudentsWithId, MODES } from './AssignmentsContentPanel/assignmentsContentPanelService';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as discussionDrawerActions from '../../actions/discussionDrawerActions';
import MultipleSelectionPanel from './MultipleSelectionPanel';
import DiscussionsContentPanel from './DiscussionsPanel/DiscussionsContentPanel';
import { I18n } from 'react-redux-i18n-lite';
import { DrawerCommonPanelCustom } from '../classroom/students/AddUsers/AddUserComponents';

const PANELS = {
  CREATE_DISCUSSION: 'CREATE_DISCUSSION',
  MULTIPLE_SELECTION: 'MULTIPLE_SELECTION'
};

export class DiscussionPanel extends Component {
  state = {
    panel: PANELS.CREATE_DISCUSSION,
    currentSelection: {
      users: []
    }
  };

  componentDidMount() {
    const { discussion, classroom, classroomActions, discussionDrawerActions } = this.props;
    classroomActions.getClassroomParticipants(classroom.id);
    this.setState({
      currentSelection: discussion.selectedGroup
    });

    if (MODES.CREATE === discussion.mode) {
      discussionDrawerActions.setTitle(`${I18n.t('panels.discussion.newDiscussion')}`);
      discussionDrawerActions.setStartDate();
      discussionDrawerActions.setDueDate();
    }
  }

  componentWillUnmount() {
    const { discussionDrawerActions } = this.props;

    discussionDrawerActions.setSelectedGroup(CONSTS.EVERYONE);
    discussionDrawerActions.setDescription();
    discussionDrawerActions.setTitle();
    discussionDrawerActions.setMode();
    discussionDrawerActions.setDiscussionId();
    discussionDrawerActions.setStartDate();
    discussionDrawerActions.setDueDate();
  }

  getDiscussion() {
    const { students, discussion } = this.props;

    return {
      students,
      ...discussion
    };
  }

  setDatesContainerInteraction = hasInteraction => {
    const { datesContainerState } = this.state;
    this.setState(Object.assign({ datesContainerState }, { hasInteraction }));
  };

  togglePanel(panel) {
    this.setState({
      panel
    });
  }

  selectStudent = newSelection => {
    const { currentSelection } = this.state;

    const users = currentSelection.users.filter(user => user._id !== newSelection._id);

    this.setState({
      currentSelection: {
        users: users.length === currentSelection.users.length ? currentSelection.users.concat(newSelection) : users
      }
    });
  };

  setSelected = () => {
    const { currentSelection } = this.state;
    const { discussionDrawerActions } = this.props;

    discussionDrawerActions.setSelectedGroup(getStudentsWithId(currentSelection));
    this.togglePanel(PANELS.CREATE_DISCUSSION);
  };

  renderMultipleSelection = () => {
    const { currentSelection } = this.state;
    const { students, discussion } = this.props;
    const hideBottomRow = currentSelection.isGroup || currentSelection.id === discussion.selectedGroup.id;

    return (
      <DrawerCommonPanelCustom
        closePanel={() => this.togglePanel(PANELS.CREATE_DISCUSSION)}
        hideRowButtons={hideBottomRow}
        panelHeaderTitle={I18n.t('panels.discussion.newDiscussion')}
        showCancelButton={true}
        handleSecondaryButtonClick={() => this.togglePanel(PANELS.CREATE_DISCUSSION)}
        primaryButtonText={'common.add'}
        secondaryButtonText={'common.back'}
        icon={'left-chevron'}
        onPrimaryButtonClick={this.setSelected}
      >
        <MultipleSelectionPanel
          students={students}
          currentSelection={currentSelection.users}
          selectStudent={this.selectStudent}
        />
      </DrawerCommonPanelCustom>
    );
  };

  renderDiscussionsContentPanel = () => {
    const { datesContainerState } = this.state;
    const discussion = this.getDiscussion();

    return (
      <DiscussionsContentPanel
        setDatesContainerInteraction={this.setDatesContainerInteraction}
        datesContainerState={datesContainerState}
        openChooseMultiple={() => this.togglePanel(PANELS.MULTIPLE_SELECTION)}
        discussion={discussion}
        mode={discussion.mode}
      />
    );
  };

  render() {
    const { panel } = this.state;

    return panel === PANELS.CREATE_DISCUSSION ? this.renderDiscussionsContentPanel() : this.renderMultipleSelection();
  }
}

DiscussionPanel.propTypes = {
  students: PropTypes.array,
  discussion: PropTypes.object,
  classroom: PropTypes.object,
  isAppOnline: PropTypes.any,
  classroomActions: PropTypes.object,
  discussionDrawerActions: PropTypes.object,
  datesContainerState: PropTypes.object
};

function mapStateToProps(state) {
  return {
    students: state.classrooms.selectedClassroom.participants.filter(participant => participant.role === ROLE.STUDENT),
    discussion: state.discussionsDrawer,
    classroom: state.classrooms.selectedClassroom.classroom,
    isAppOnline: state.connection.status.online
  };
}

function mapDispatchToProps(dispatch) {
  return {
    discussionDrawerActions: bindActionCreators(discussionDrawerActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionPanel);
